module.exports = __webpack_public_path__ + "static/media/landing.08e18cb9.jpg";